import React, { useEffect, useState } from 'react'
import Sidebar from '../components/Sidebar'
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';

export default function Categories() {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([])

  


  useEffect(() => {
    setCategories(JSON.parse(sessionStorage.getItem('GPP_Games_Data')))
  }, [])



  return (
    <div>
      <Sidebar />

      <div className='main-body' >
        <BackButton />
        <h4 className='my-3' ><strong>Categories</strong></h4>


        <div className='category_grid' >
          {categories.map((cat, index) => (
            <div
              key={index}
              className='category_card' 
              onClick={() =>
                navigate('/dashboard/single', {
                  state: { category: cat } // passing data via state
                })
              }
            >
              <img src={cat.Icon} />
              <p>{cat.Name} ({cat.Content.length})</p>
            </div>
          ))}

        </div>
      </div>
    </div>
  )
}
